/**
 * Created by Ning Jiang on 8/16/2018.
 */

import {TimelineMax, TweenLite} from "gsap";
import {DisplayObject} from "pixi.js";

import ("pixi.js");

export interface IShakeConfig {
    x: number;
    y: number;
    obj: DisplayObject;
    duration: number;
    Intensity?: number;
    hertz: number;
    ease?: any;
    reverseEase?: boolean;
    positionCb?: () => PIXI.Point;
}

export class WgShakingDisplayObject {
    private _stopped: boolean = true;

    private readonly _object: PIXI.DisplayObject;

    public get object(): PIXI.DisplayObject {
        return this._object;
    }

    constructor(displayObject: PIXI.DisplayObject) {
        this._object = displayObject;
    }

    public textPlacedAnimation(frequency: number, x: number, y: number): void {
        this._stopped = false;

        TweenLite.fromTo(this._object.scale, frequency,
            {
                x: this._object.scale.x + x,
                y: this._object.scale.y + y
            },
            {
                x: this._object.scale.x,
                y: this._object.scale.y,
                onComplete: () => {
                    if (this._stopped) {
                        return;
                    }
                    this.textPlacedAnimation(frequency, x, y);
                },
                clearProps: "scale"
            });
    }

    public shake(frequency: number, maxOffset: number): void {
        this._stopped = false;

        TweenLite.fromTo(this._object, frequency,
            {
                x: this._object.x + WgShakingDisplayObject.getShakeOffset(maxOffset)
            },
            {
                x: this._object.x,
                onComplete: () => {
                    if (this._stopped) {
                        return;
                    }
                    this.shake(frequency, maxOffset);
                },
                clearProps: "x"
            });
    }

    public scatterAnticipationShake(frequency: number, y: number): void {
        this._stopped = true;
        let randomY: number = WgShakingDisplayObject.getShakeOffset(y);
        TweenLite.fromTo(this._object, frequency,
            {
                y: this._object.position.y + randomY
            },
            {
                y: this._object.position.y,
                onComplete: () => {
                    this._object.position.set(0, 0);
                    if (this._stopped) {
                        return;
                    }
                    this.shake(frequency, y);
                },
                clearProps: "x,y"
            });
    }

    public warriorAttackShake(frequency: number, x: number): void {
        this._stopped = true;
        TweenLite.fromTo(this._object, frequency,
            {
                x: this._object.position.x - x,
            },
            {
                x: this._object.position.y,
                onComplete: () => {
                    this._object.position.set(0, 0);
                    if (this._stopped) {
                        return;
                    }
                },
                clearProps: "x,y"
            });
    }

    public stopShake(): void {
        this._stopped = true;
    }

    private static getShakeOffset(offset: number): number {
        return Math.floor(Math.random() * (offset + offset + 1) - offset);
    }

    public static punkShake(config: IShakeConfig): TimelineMax {
        let startPosY: number = config.obj.y;
        let startPosX: number = config.obj.x;

        let t: boolean = true;
        const tl: TimelineMax = new TimelineMax({
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete: () => {
                config.obj.y = startPosY;
                config.obj.x = startPosX;
                if (config.positionCb) {
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }
            },
            onUpdate: () => {
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = config.ease ? config.ease.getRatio(nt) as number : nt;
                if (t) {
                    t = false;
                    return;
                }
                if (config.positionCb) {
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }

                if (config.reverseEase)
                    et = 1 - et;
                if (config.Intensity) {
                    if (config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt * config.hertz) * (config.Intensity * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * (config.Intensity * et)) * config.x;
                } else {
                    if (config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt * config.hertz) * et) * config.y;
                    if (config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt * config.hertz) * et) * config.x;
                }
            }
        });
        tl.to(this, config.duration, {});
        return tl;
    }
}